export class InviteInvalidType extends Error {
  public constructor() {
    super()

    this.message = 'invitePage.inviteErrors.invalidType'
  }
}
